import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { COMPANY_CODE_MODULE, DEFAULT_COLUMN } from "../constant/companyCodeConstant";

export const setCompanyCodePreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: COMPANY_CODE_MODULE,
    default_columns: DEFAULT_COLUMN,
    default_order_by: '',
    default_order: 'asc',
});
